.header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: color-mix(in srgb, var(--paper) 94%, transparent);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--rule);
}

.inner {
  padding-block: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
}

.brand {
  display: block;
}

.nav {
  display: flex;
  align-items: center;
  gap: 22px;
  flex-wrap: wrap;
}

.navLink {
  font-size: 15px;
  color: var(--ink-muted);
  padding-block: 12px;
}

.navLink:hover {
  color: var(--ink);
}

.langWrap {
  display: flex;
  align-items: center;
  padding-left: 22px;
  border-left: 1px solid var(--rule);
}

/* Below the fold of a phone the nav wraps under the wordmark on its own line, so it
   needs the gutter back rather than sitting flush against the logo. */
@media (max-width: 560px) {
  .inner {
    gap: 4px 14px;
  }

  .nav {
    gap: 16px;
  }

  .langWrap {
    padding-left: 16px;
  }
}
